var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { AgencyService } from '../common-theme/api/agency.service';
var AboutUsComponent = /** @class */ (function (_super) {
    __extends(AboutUsComponent, _super);
    function AboutUsComponent(router, agencyService, injector) {
        var _this = _super.call(this, injector) || this;
        _this.router = router;
        _this.agencyService = agencyService;
        _this.isOpen = [true, false, false, false, false];
        _this.navLinks = [
            { path: '/despre-noi/istorie' },
            { path: '/despre-noi/proiect' },
            { path: '/despre-noi/facilitati' },
            { path: '/despre-noi/finisaje' }
        ];
        return _this;
    }
    AboutUsComponent.prototype.ngOnInit = function () {
        this.meta.addTags([
            { name: 'robots', content: 'noindex' }
        ]);
        this.setTitle(this.agencyService.agency.name);
        this.router.navigate(['despre-noi/istorie']);
    };
    return AboutUsComponent;
}(SeoAwareBaseComponent));
export { AboutUsComponent };



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.ts.pre-build-optimizer.js